import { c as _c } from "react/compiler-runtime";
import { useI18n } from '@/context/I18nProvider';
import { Clock } from 'lucide-react';
const MessagesSeparator = t0 => {
  const $ = _c(10);
  const {
    label
  } = t0;
  const {
    t
  } = useI18n();
  let t1;
  if ($[0] !== label || $[1] !== t) {
    t1 = label ?? t("messages.upcomingMessages");
    $[0] = label;
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const displayLabel = t1;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="h-[1px] flex-1 bg-amber-300" />;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Clock className="size-3 text-amber-600" />;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== displayLabel) {
    t4 = <div className="flex items-center gap-1.5 px-2 py-1 rounded-full bg-amber-50 border border-amber-200">{t3}<span className="text-xs font-medium text-amber-700">{displayLabel}</span></div>;
    $[5] = displayLabel;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="h-[1px] flex-1 bg-amber-300" />;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t4) {
    t6 = <div className="flex items-center gap-2 my-4">{t2}{t4}{t5}</div>;
    $[8] = t4;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  return t6;
};
export { MessagesSeparator };